module.exports = __webpack_public_path__ + "img/shutdown-system.278ccc72.svg";